import {APP_INITIALIZER, enableProdMode, NgModule} from '@angular/core';

import {APP_ROUTES} from './app.routes';
import {AppComponent} from './app.component';
import {CORE_MODULES} from './core';
import {RouterModule} from '@angular/router';
import {ToasterComponent} from '@core/modules/notification/components/toast.component';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {ConfigService} from '@core/config/config.service';
import {TranslateService} from '@core/modules/translation';

export function loadConfig(configService: ConfigService) {
	return () =>
		configService.loadAppConfig().then(() => {
			if (configService.isProduction()) {
				enableProdMode();
			}
		});
}

export function loadTranslations(translate: TranslateService) {
	// Wait for the active language's JSON before bootstrapping so components
	// never render raw translation keys on slow connections. Degrade
	// gracefully (keep booting) if the translation file fails to load.
	return () => translate.init().catch(() => undefined);
}

@NgModule({
	declarations: [AppComponent],
	bootstrap: [AppComponent],
	imports: [
		...CORE_MODULES,
		RouterModule.forRoot(APP_ROUTES),
		ToasterComponent,
		StoreModule.forRoot({}),
		EffectsModule.forRoot(),
		// StoreDevtoolsModule.instrument({
		// 	maxAge: 25, // Retains last 25 states
		// 	autoPause: true, // Pauses recording actions and state changes when the extension window is not open
		// }),
	],
	providers: [
		{
			provide: APP_INITIALIZER,
			useFactory: loadConfig,
			deps: [ConfigService],
			multi: true,
		},
		{
			provide: APP_INITIALIZER,
			useFactory: loadTranslations,
			deps: [TranslateService],
			multi: true,
		},
	],
})
export class AppModule {}
